export default {
  name: "Personen",

  api: {
    person: {
      firstNameLastName: {
        orRequired: "De persoon heeft een naam nodig",
      },
    },
  },
}
